import React from 'react';
import './Header.css';

export default function Header() {
  return (
    <header className="header">
      <div className="header__logo">
        {/* swap in your SVG or img */}
        <span className="header__logo-icon">
            <img src={require('../assets/logo/logo.png')} alt="AID"/>
        </span>
      </div>
      <nav className="header__nav">
        <div className="nav_holder">
            <a href="/">Home</a>
            <a href="/">Payment</a>
            <a href="/">Partnership</a>
            <a href="/">About</a>
            <a href="/">Contact</a>
        </div>
        <div className="nav_button_holder">
            <a href="/" className="btn-login">Log In</a>
            <a href="/" className="btn-signup">Sign Up</a>
        </div>
      </nav>
    </header>
  );
}
